import { Text } from '../../common/designs'
import { PROCESS_FORM_TIP_BOX } from './constants'
import StepMatchingCriteriaSection from './StepMatchingCriteriaSection'
import type { StepCriteriaRow } from './types'

interface Props {
  stepsInheritingIdFromPrevWindow: StepCriteriaRow[]
  setStepsInheritingIdFromPrevWindow: (rows: StepCriteriaRow[]) => void
  stepsInheritingIdFromNextWindow: StepCriteriaRow[]
  setStepsInheritingIdFromNextWindow: (rows: StepCriteriaRow[]) => void
  stepsInheritingIdWhenInMultiSystemFlow: StepCriteriaRow[]
  setStepsInheritingIdWhenInMultiSystemFlow: (rows: StepCriteriaRow[]) => void
  onRegisterNewRowNeedsApply: (rowClientId: string) => void
  onRowRuleApplied: (rowClientId: string) => void
  onRowRuleRemoved: (rowClientId: string) => void
}

const ProcessFormAdvancedTabContent = ({
  stepsInheritingIdFromPrevWindow,
  setStepsInheritingIdFromPrevWindow,
  stepsInheritingIdFromNextWindow,
  setStepsInheritingIdFromNextWindow,
  stepsInheritingIdWhenInMultiSystemFlow,
  setStepsInheritingIdWhenInMultiSystemFlow,
  onRegisterNewRowNeedsApply,
  onRowRuleApplied,
  onRowRuleRemoved,
}: Props) => (
  <>
    <div className={PROCESS_FORM_TIP_BOX}>
      <Text size='s' color='gray' className='leading-relaxed'>
        NOTE: Apply commits the fields on a card into the rule row that Save will send. Save is
        always available; new rows from Add rule are omitted from the request until you apply that
        row once. Basic settings are saved together from the other tab.
      </Text>
    </div>

    <div className='max-h-[min(32rem,calc(100dvh-14rem))] overflow-y-auto overscroll-y-contain rounded-lg border border-gray-200/90 bg-gray-50/50 py-2 pl-1 pr-2 shadow-inner [-webkit-overflow-scrolling:touch]'>
      <div className='space-y-3 px-1 pb-1'>
        <StepMatchingCriteriaSection
          title='Steps Shown After Id-Window'
          description=''
          rowKeyPrefix='after-id-window'
          currentStepCriteriaArray={stepsInheritingIdFromPrevWindow}
          onUpdateStepCriteriaArray={setStepsInheritingIdFromPrevWindow}
          isDistanceMetricsEnabled
          onRegisterNewRowNeedsApply={onRegisterNewRowNeedsApply}
          onRowRuleApplied={onRowRuleApplied}
          onRowRuleRemoved={onRowRuleRemoved}
        />
        <StepMatchingCriteriaSection
          title='Steps Shown Before Id-Window'
          description=''
          rowKeyPrefix='before-id-window'
          currentStepCriteriaArray={stepsInheritingIdFromNextWindow}
          onUpdateStepCriteriaArray={setStepsInheritingIdFromNextWindow}
          isDistanceMetricsEnabled
          onRegisterNewRowNeedsApply={onRegisterNewRowNeedsApply}
          onRowRuleApplied={onRowRuleApplied}
          onRowRuleRemoved={onRowRuleRemoved}
        />
        <StepMatchingCriteriaSection
          title='Steps Shown During Multi-System Flows'
          description=''
          rowKeyPrefix='multi-system-flow'
          currentStepCriteriaArray={stepsInheritingIdWhenInMultiSystemFlow}
          onUpdateStepCriteriaArray={setStepsInheritingIdWhenInMultiSystemFlow}
          onRegisterNewRowNeedsApply={onRegisterNewRowNeedsApply}
          onRowRuleApplied={onRowRuleApplied}
          onRowRuleRemoved={onRowRuleRemoved}
        />
      </div>
    </div>
  </>
)

export default ProcessFormAdvancedTabContent
